export { default } from './SmallCard';
export type { SmallCardProps } from './SmallCard';
